var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group form-group--textarea", class: _vm.getClass() },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { class: `col-sm-${_vm.component.size}` },
          [
            _c("label", [
              _vm._v(_vm._s(_vm.component.label) + "\n        "),
              _vm.isRequired()
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
            ]),
            _vm.component.isTextEditor === false
              ? _c("textarea", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.setRules(),
                      expression: "setRules()",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.component.data.currentValue,
                      expression: "component.data.currentValue",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: _vm.component.key,
                    name: _vm.component.key,
                    disabled: _vm.disabledHandler(),
                    rows: _vm.component.rows,
                    placeholder: _vm.component.placeholder,
                    minLength: _vm.component.validate.minLength,
                    maxLength: _vm.component.validate.maxLength,
                    "data-vv-name": _vm.component.key,
                  },
                  domProps: {
                    value: _vm.component.data.currentValue,
                    innerHTML: _vm._s(_vm.component.data.currentValue),
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.focusHandler()
                    },
                    blur: function ($event) {
                      return _vm.blurHandler()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.component.data,
                        "currentValue",
                        $event.target.value
                      )
                    },
                  },
                })
              : _vm._e(),
            _vm.component.isTextEditor === true
              ? _c("quill-editor", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.setRules(),
                      expression: "setRules()",
                    },
                  ],
                  ref: "myTextEditor",
                  attrs: {
                    name: "descricao",
                    options: _vm.editorOption,
                    id: _vm.component.key,
                    name: _vm.component.key,
                    disabled: _vm.disabledHandler(),
                    rows: _vm.component.rows,
                    placeholder: _vm.component.placeholder,
                    minLength: _vm.component.validate.minLength,
                    maxLength: _vm.component.validate.maxLength,
                    "data-vv-name": _vm.component.key,
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.focusHandler()
                    },
                    blur: function ($event) {
                      return _vm.blurHandler()
                    },
                  },
                  model: {
                    value: _vm.component.data.currentValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.component.data, "currentValue", $$v)
                    },
                    expression: "component.data.currentValue",
                  },
                })
              : _vm._e(),
            _vm.errors.has(_vm.component.key)
              ? _c("span", { staticClass: "help-block help-block--bottom" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 14 14",
                        width: "14",
                      },
                    },
                    [
                      _c(
                        "g",
                        { attrs: { transform: "translate(-252 -635)" } },
                        [
                          _c("rect", {
                            staticClass: "cls-1",
                            attrs: {
                              width: "14",
                              height: "14",
                              transform: "translate(252 635)",
                            },
                          }),
                          _c("path", {
                            staticClass: "cls-2",
                            attrs: {
                              d: "M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z",
                              transform: "translate(251 634)",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.errors.first(_vm.component.key)) +
                      "\n      "
                  ),
                ])
              : _vm._e(),
            _c("div", { staticClass: "help-block-container" }, [
              _c("div", { staticClass: "help-block-container__helper" }, [
                !_vm.errors.has(_vm.component.key)
                  ? _c(
                      "span",
                      { staticClass: "help-block help-block--bottom" },
                      [_vm._v(_vm._s(_vm.component.description))]
                    )
                  : _vm._e(),
              ]),
              _c("div", [
                !_vm.errors.has(_vm.component.key) &&
                _vm.component.validate.maxLength
                  ? _c(
                      "span",
                      { staticClass: "help-block help-block--bottom" },
                      [
                        _vm._v(
                          _vm._s(
                            `${_vm.component.data.currentValue.length}/${_vm.component.validate.maxLength}`
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }